import { render, staticRenderFns } from "./GftSwiperThumbs.vue?vue&type=template&id=9639e7d6"
import script from "./GftSwiperThumbs.vue?vue&type=script&lang=ts"
export * from "./GftSwiperThumbs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports